import React from "react";

export default props => {
  const {
    list,
    openDetailPopup,
    deleteAllergy,
    openAddPopup,
    openModPopup,
    allergyType,
  } = props;

  let allergyName = list.allergyName;
  let symptomDT = list.symptomDT;
  let registDate =
    list.registDate.substring(0, 4) +
    "." +
    list.registDate.substring(4, 6) +
    "." +
    list.registDate.substring(6, 8);
  let symptomType; //증상
  let symptomCssType; //증상

  // 약품명이 특정자리수 이상인 경우 ... 처리필요
  if (allergyName.length > 11) {
    allergyName = allergyName.substring(0, 11) + "...";
  }

  if (symptomDT.length > 2) {
    symptomDT =
      list.symptomDT.substring(0, 4) + "." + list.symptomDT.substring(4, 6);
  }

  if (list.symptomType == 0) {
    symptomType = "의심";
    symptomCssType = "i_symptom suspect";
  } else if (list.symptomType == 1) {
    symptomType = "확실";
    symptomCssType = "i_symptom certain";
  }

  return (
    <div className="allergy-line-box">
      <ul>
        <li>
          <strong>
            {(list.allergyType == 0) | (list.allergyType == 2)
              ? "약품명"
              : "알레르기"}
          </strong>
          <span>{allergyName}</span>
          {(allergyType == "0" || allergyType == "2") && (
            // &&  <button className="btn_search" onClick={()=>openDetailPopup(list.foodId, list.medicineId, list.allergyName)}></button>
            <button
              className="btn_detail"
              onClick={() =>
                openDetailPopup(list.foodId, list.medicineId, list.allergyName)
              }></button>
          )}
          <button
            className="btn_modify"
            onClick={
              list.medicineId
                ? () =>
                    openModPopup(
                      list.foodId,
                      list.medicineId,
                      list.allergyName,
                      list.symptomDT,
                      list.symptomInfo,
                      list.symptomType,
                      list.allergyId
                    )
                : () =>
                    openModPopup(
                      list.foodId,
                      "",
                      list.allergyName,
                      list.symptomDT,
                      list.symptomInfo,
                      list.symptomType,
                      list.allergyId
                    )
            }></button>
        </li>

        {list.ingredientName != "" && (
          <li>
            <strong>성분명</strong>
            {list.ingredientName}
          </li>
        )}

        <li>
          <strong>증상시점</strong>
          {symptomDT}
        </li>
        <li>
          <strong>증상</strong>
          {list.symptomInfo}

          <p className="symptomInfo">
            <span className={symptomCssType}>{symptomType}</span>
          </p>
        </li>
        <li>
          <strong>등록일</strong>
          {registDate}
          <button
            className="btn_delete"
            onClick={() =>
              deleteAllergy(
                "알레르기 삭제",
                "등록한 알레르기를 삭제하겠습니까?",
                list.allergyId
              )
            }></button>
        </li>
      </ul>
    </div>
  );
};
